import React from 'react';
import Image from 'next-export-optimize-images/image';
import { useABTestVariant } from '../ABTest';
import { DE_LP_EXPERIMENT, DE_LP_EXPERIMENT_ID } from '@data/surveyConfigs';

const DoctorReview = () => {
    const variant = useABTestVariant(DE_LP_EXPERIMENT.experiment);
    if(!variant || variant === DE_LP_EXPERIMENT_ID.A) {
        return null;
    }
    return (
        <div className="flyntComponent componentSpacing themeLight" data-testid="doctorReview">
            <div className="container centerMaxWidthContainer relative overflow-hidden md:overflow-visible">
                <div className="absolute top-[30px] left-[-25px] md:top-[100px] md:left-[-58px] z-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="391" height="391" viewBox="0 0 391 391" fill="none">
                        <g filter="url(#filter0_d_209_462)">
                            <ellipse cx="195.716" cy="195.526" rx="1.55103" ry="1.66974" fill="#0DCBAA" />
                        </g>
                        <defs>
                            <filter id="filter0_d_209_462" x="0.965179" y="0.656448" width="389.502" height="389.739" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feMorphology radius="95" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_209_462" />
                                <feOffset />
                                <feGaussianBlur stdDeviation="49.1" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0.0509804 0 0 0 0 0.796078 0 0 0 0 0.666667 0 0 0 1 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_209_462" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_209_462" result="shape" />
                            </filter>
                        </defs>
                    </svg>
                </div>
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-[130px] py-8 z-10 relative">
                    <div className="flex-shrink-0">
                        <div className="w-[290px] h-[290px] md:w-[400px] md:h-[400px]">
                            <Image
                                className="w-full h-full object-cover rounded-full"
                                width={400}
                                height={400}
                                src="/images/dr-med-jonas-laaser.webp"
                                alt="Dr. med. Jonas Laaser"
                                style={{
                                    backgroundColor: '#ccc',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#666',
                                    fontSize: '14px'
                                }}
                            />
                        </div>
                    </div>

                    <div className="flex-1">
                        <blockquote className="text-xl md:text-2xl leading-relaxed italic text-slate-700 font-normal m-0">
                            &bdquo;Patientinnen und Patienten können – wenn sie es schaffen, kontinuierlich mit der App zu arbeiten – echt profitieren&ldquo;
                        </blockquote>
                        <p className="text-lg font-semibold text-slate-700 mt-4 mb-4 m-0">Dr. med. Jonas Laaser</p>
                        <a
                            target="_blank"
                            href="https://oviva.com/de/de/experten-testimonial-jonas-laaser/"
                        >
                            Erfahrungsbericht lesen
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoctorReview;